(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.topicOneOnOneKind = _exports.topicModerationVerifiedStatus = _exports.topicModerationRejectedStatus = _exports.topicModerationPendingStatus = _exports.topicGroupKind = _exports.topicFishbowlKind = _exports.topicEntityKey = void 0;

  /**
   * Entity key used by the topic schema
   * @type {string}
   */
  var topicEntityKey = "topics";

  /**
   * Value of `kind` for a one-on-one topic
   * @type {TopicKindOneOnOne}
   */
  _exports.topicEntityKey = topicEntityKey;
  var topicOneOnOneKind = "offer";

  /**
   * Value of `kind` for a group topic
   * @type {TopicKindGroup}
   */
  _exports.topicOneOnOneKind = topicOneOnOneKind;
  var topicGroupKind = "group";

  /**
   * Value of `kind` for a fishbowl topic
   * @type {TopicKindFishbowl}
   */
  _exports.topicGroupKind = topicGroupKind;
  var topicFishbowlKind = "fishbowl";

  /**
   * Value of `moderation` for a pending topic
   * @type {string}
   */
  _exports.topicFishbowlKind = topicFishbowlKind;
  var topicModerationPendingStatus = "pending";

  /**
   * Value of `moderation` for a rejected topic
   * @type {string}
   */
  _exports.topicModerationPendingStatus = topicModerationPendingStatus;
  var topicModerationRejectedStatus = "rejected";

  /**
   * Value of `moderation` for a verified topic
   * @type {string}
   */
  _exports.topicModerationRejectedStatus = topicModerationRejectedStatus;
  var topicModerationVerifiedStatus = "verified";
  _exports.topicModerationVerifiedStatus = topicModerationVerifiedStatus;
});